import React from "react";
import  "./footer.css";
import logo from "../../assets/logoFairAgro-noBG.png";
import face from "../../assets/face.png";
import insta from "../../assets/insta.png";
import link from "../../assets/linkedin.png";

export const Footer = () => {
    return (
        <div className="footerContainer">
            <p>E-mail de contato: gofairagro@gmail.com</p>
            <a href="https://r1.ufrrj.br/petsi/">Desenvolvido por PET-SI/UFRRJ</a>
        </div>
    )
}